import React from 'react';
import { Form, Input, Button, message, Divider } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined, SafetyOutlined } from '@ant-design/icons';
import { Link, Navigate } from 'react-router-dom';
import { login } from '../../api/sys_user';
import { setAuth, isAuthenticated, getUser } from '../../utils/auth';
import { canManageUsers, isNormalUser } from '../../utils/role';
import AuthShell from '../AuthShell/AuthShell';

const getHomePath = (user) => {
    if (canManageUsers(user)) return '/admin/users';
    if (isNormalUser(user)) return '/admin/videos';
    return '/admin/videos';
};

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            redirectTo: null,
        };
    }

    componentDidMount() {
        if (isAuthenticated()) {
            this.setState({ redirectTo: getHomePath(getUser()) });
        }
    }

    onFinish = async (values) => {
        this.setState({ loading: true });
        try {
            const data = await login(values.loginId, values.password);
            setAuth(data.token, data.user);
            message.success('登录成功，欢迎回来');
            const home = getHomePath(data.user);
            const { onLogin } = this.props;
            if (onLogin) {
                onLogin(() => this.setState({ redirectTo: home }));
            } else {
                this.setState({ redirectTo: home });
            }
        } catch (error) {
            const msg = error.message || '登录失败';
            if (error.responseStatus === '429') {
                message.warning({ content: msg, duration: 8, key: 'login-rate-limit' });
            } else {
                message.error(msg);
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { loading, redirectTo } = this.state;
        if (redirectTo) {
            return <Navigate to={redirectTo} replace />;
        }

        return (
            <AuthShell title="欢迎回来" subtitle="请使用您的账号登录">
                <Form
                    name="login"
                    onFinish={this.onFinish}
                    size="large"
                    layout="vertical"
                    requiredMark={false}
                >
                    <Form.Item
                        name="loginId"
                        label="登录名"
                        rules={[{ required: true, message: '请输入登录名' }]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="请输入登录名"
                            allowClear
                            autoComplete="username"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="密码"
                        rules={[{ required: true, message: '请输入密码' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="请输入密码"
                            autoComplete="current-password"
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 8 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="auth-btn-primary"
                            block
                            loading={loading}
                            icon={<LoginOutlined />}
                        >
                            立即登录
                        </Button>
                    </Form.Item>
                    <div className="auth-footer">
                        <Divider plain style={{ margin: '0 0 16px', borderColor: 'rgba(56,189,248,0.12)' }}>
                            <span style={{ color: '#64748b', fontSize: 12 }}>
                                <SafetyOutlined style={{ marginRight: 6, color: '#22d3ee' }} />
                                安全登录
                            </span>
                        </Divider>
                        <Link to="/register" className="auth-link">
                            还没有账号？立即注册
                        </Link>
                    </div>
                </Form>
            </AuthShell>
        );
    }
}

export default LoginPage;
